var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-player cx-div"},[_c('audio',{ref:"player",staticStyle:{"width":"100%"},attrs:{"controls":"","autoplay":"","src":_vm.getMediaHost(_vm.audio, 'MGTO')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }